import { AjaxClient } from './ajax-client';
import { UnreadNewsCountResponseShape } from './news-api-types';

export const MAX_RETRIES = 3;

class MaxAttemptsExceededError extends Error {}

export const NewsClient = new (class {
  async getUnreadNews(employeeId: string, stage: string) {
    const params = new URLSearchParams();
    params.append('employeeId', employeeId);

    const response = await this.requestWithRetries<
      UnreadNewsCountResponseShape
    >(() =>
      AjaxClient.get(
        stage,
        `/${employeeId}/comms/count?${params.toString()}`,
        null
      )
    );

    return response.unrenderedCommsCount === undefined ||
      response.unrenderedCommsCount === ''
      ? 0
      : Number(response.unrenderedCommsCount);
  }

  async requestWithRetries<T>(fn: () => Promise<unknown>) {
    let attempts = 0;
    while (attempts < MAX_RETRIES) {
      try {
        const result = (await fn()) as { response: T };
        // TODO: maybe a unsuccessful response code?
        return result.response;
      } catch (e) {
        // Only retry for 500 statuses (server errors), otherwise throw error
        if (Math.floor(e.status / 100) !== 5) {
          throw e;
        }
      } finally {
        attempts++;
      }
    }

    throw new MaxAttemptsExceededError();
  }
})();
